




































  import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { Address, DebitCardDeactivationReasons, DebitCardManagerModalViewState, CardStatus } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import * as datadog from "@/shared/datadog";
import { Validator } from "vee-validate";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
    }
  })
  export default class DeactivateCardAddressConfirmForm extends Vue {
    $validator: Validator;
    debitCardManagementStore = useDebitCardManagementStore();
    contactInfoStore = useContactInfoStore();
    themeStore = useThemeStore();

    RouteNames = RouteNames;

    formIsBeingSubmitted = false;

    mounted (): void {
      this.contactInfoStore.getContactInformation();
    }

    get mailingAddress (): Address {
      if (!this.contactInfoStore.contactInformation
        || !this.contactInfoStore.contactInformation.mailingAddress) {
        const data = {
          cardNumberLast4: this.debitCardManagementStore.focusedDebitCard.cardNumberLast4,
          userDate: Date.now()
        };

        datadog.log(`MailingAddress not found`, data, "error");
        return null;
      }
      return this.contactInfoStore.contactInformation.mailingAddress;
    }

    onSubmitChanges (e: Event) {
      e.preventDefault();
      this.orderReplacementCard();
    }

    orderReplacementCard () {
      this.formIsBeingSubmitted = true;
      this.debitCardManagementStore.orderReplacementDebitCard(
        {
          cardStatus: this.getCardStatus(this.debitCardManagementStore.deactivationReason)
        })
        .then(() => {
          this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.DeactivateCardCompleteForm);
        })
        .finally(() => {
          this.formIsBeingSubmitted = false;
        });
    }

    getCardStatus (deactivationReason) {
    switch (deactivationReason) {
      case DebitCardDeactivationReasons.DamagedCard:
      case DebitCardDeactivationReasons.Lost:
        return CardStatus.LostOrDamaged;
      case DebitCardDeactivationReasons.FraudulentActivity:
        return CardStatus.Fraud;
      case DebitCardDeactivationReasons.Stolen:
        return CardStatus.Stolen;
    }
  }
}
